import { action, computed } from 'mobx';
import { Services } from '../services';
import { Watchlists } from '../models/configuration/Watchlists';
import { BaseStore } from './BaseStore';
import { GlobalWatchlistConfigSource } from '../models/configuration/global/GlobalWatchlistConfigSource';

export class WatchlistStore extends BaseStore {
    isInitialized: boolean = false;
    watchlists: Watchlists | undefined;
    upsertTimeout;
    @computed
    get source(): GlobalWatchlistConfigSource {
        return (
            (this.stores.data &&
                this.stores.data.config &&
                this.stores.data.config.globalWatchlistConfig.source) ||
            GlobalWatchlistConfigSource.localStorage
        );
    }

    @computed
    get isUserConfiguration(): boolean {
        return this.source === GlobalWatchlistConfigSource.userConfiguration;
    }

    @computed
    get isLocalStorage(): boolean {
        return this.source === GlobalWatchlistConfigSource.localStorage;
    }

    @action
    initialize = async (): Promise<void> => {
        if (this.isUserConfiguration && !this.isInitialized) {
            await this.fetchWatchlists();
            this.isInitialized = true;
        }
    };

    @action
    fetchWatchlists = async (): Promise<Watchlists> => {
        try {
            const watchlists = await (this.stores.data
                .services as Services).getWatchlists();
            this.watchlists = (watchlists || {}) as Watchlists;
        } catch (e) {
            console.warn('Fetch Watchlist |', e);
        }
        return this.watchlists;
    };

    @action
    upsertWatchlists = async (): Promise<void> => {
        clearTimeout(this.upsertTimeout);
        // This timeout allows us to hold off firing too many upserts while the user is still busy
        this.upsertTimeout = setTimeout(async () => {
            try {
                await (this.stores.data.services as Services).setWatchlists(
                    this.watchlists
                );
            } catch (e) {
                console.warn('Upsert Watchlist |', e);
            }
        }, 2000);
    };

    @action
    getWatchlist = (key: string): Array<string> => {
        if (this.isLocalStorage) {
            return JSON.parse(localStorage.getItem(key)) || [];
        }
        if (this.isUserConfiguration && this.watchlists) {
            return this.watchlists[key] || [];
        }
        return [];
    };

    @action
    setWatchlist = (key: string, value: Array<string>) => {
        if (this.isLocalStorage) {
            localStorage.setItem(key, JSON.stringify(value));
        }
        if (this.isUserConfiguration) {
            if (!this.watchlists) {
                this.watchlists = {};
            }
            this.watchlists[key] = value;
            this.upsertWatchlists();
        }
    };
}



// WEBPACK FOOTER //
// ./src/stores/WatchlistStore.ts